// extracted by mini-css-extract-plugin
export default {"nowTime":"NowTimeBar_nowTime__uWhhX"};